import React, { FunctionComponent, useState } from "react";
import UserTokenQueryRenderer from "@/Domains/AuthenticationManagement/Usertoken/Queryrenderer/UserTokenQueryRenderer";
import {useParams} from "react-router-dom";
import {
    UserTokenMainQueryRendererQueryResponse
} from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserTokenMainQueryRendererQuery.graphql";

interface IUserTokenMainView {
    viewData: UserTokenMainQueryRendererQueryResponse;
}

const UserTokenMainView: FunctionComponent<IUserTokenMainView> = (props) => {
    const { token } = useParams();
    return <UserTokenQueryRenderer {...props} token={token} />;
};

export default UserTokenMainView;
